import React from 'react';
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { connect } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import { toast } from 'react-toastify';
import Ax from "../../components/hoc/Ax";
import { Collapse, Modal } from 'bootstrap';
import tapIcon from "../../services/TapIcon";
import HttpAPICall from '../../services/HttpAPICall';
import errorValidation from '../../services/ErrorValidation'
import TapSelect from "../../components/ui/TapSelect";
import { DisplayListPagination, DisplaySearchCriteria } from '../../components/TapUi';
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from '../../services/TapApiUrls';
import Status from '../../components/ui/Status';
import DownloadFile from "../../services/DownloadFile";
import download from '../../services/DownloadFile';
import AppBaseComponent from '../../components/AppBaseComponent';
import InterchangeableItem from './InterchangeableItem';
import ChangeItemStatus from './includes/ChangeItemStatus';
import ItemInventory from './ItemInventory';
import ItemDetailsTab from './itemDetails/ItemDetailsTab';
import { Helmet } from 'react-helmet';
import * as actions from '../../store/actions/index';
import { Link } from 'react-router-dom';
import swal from "sweetalert"
import OpeningBalanceAddModal from '../settings/itemOpeningBalance/OpeningBalanceAddModal';
import ItemWhConfig from './configuration/ItemWhConfig';
import ItemAdditionalAttributes from './ItemAdditionalAttributes';
import ChildItems from './ChildItems';
import ItemCard from './ItemCard';
import Document from './Document';
import api from '../../services/api';
import TapHelper from '../../services/TapHelper';
import ReusableItemTabs from './ReusableItemsTabs';


class ItemList extends AppBaseComponent {

    constructor(props) {
        super(props);
            this.criteriaRef = React.createRef();

        this.itemSearchFormInitialState = {
            'search_name': '',
            'search_status': '',
            'search_item_code': '',
            'search_category': '',
            'search_manufacturer_id': '',
            'search_manufacturer_part_no': '',
            'search_gst_code': '',
            'search_hsn_code': '',
            'search_item_tags': [],
            'search_by_text'                     :   '',
        };

        this.itemSearchFormLabel = {
            'search_name': 'Item Name : ',
            'search_item_code': 'Item Code : ',
            'search_status': 'Item Status : ',
            'search_category': 'Category : ',
            'search_manufacturer_id': 'Manufacturer : ',
            'search_manufacturer_part_no': 'Manufacturer Part No : ',
            'search_gst_code': 'GST : ',
            'search_hsn_code': 'HSN / SAC Code : ',
            'search_item_tags': 'Item Tags : ',
            'search_by_text'                     :   'Search Text : ',

        };


        this.state = {
            listing_tbl_page: 1,
            listing_loading: this.props.item_listing_loaded,
            listingMeta: null,
            listingData: [],
            item_additional_attributes: [],
            itemData: null,
            totalListingCount: 0,
            minimizeTable: false,
            itemSearchForm: { ...this.itemSearchFormInitialState },
            itemSearchedElems: [],
            formSearchedElems: [],
            searchedElems: null,
            itemSearchParams: null,
            itemAddScreenView: false,
            itemAddFormData: null,
            itemBulkUploadFormSubmitting: false,
            itemBulkUpdateFormSubmitting: false,
            itemUpdateScreenView: false,
            itemFormDataLoaded: false,
            filterFormData: [],
            form_loading: false,
            details_loading: false,
            allManufacturers: [],
            allTags: [],
            itemId: null,
            itemName: '',
            enc_item_id: props.match.params.id,
            tabScreen: this.props.match.params.tab,
            category: '',
            excelDownloading: false,
            minimize: false,
            itemDisplayName: '',
            refreshDetail: false,
            refreshInventoryLevel: false,
            itemStatus: '',
            changeStatus: false,
            allStatus: [],
            collapseOpenClose: null,
            itemDetail : null,
            criteriaHeight              :            0 ,

        };
        this.updateItemScreenInit = this.updateItemScreenInit.bind(this);
        this.openingBalanceRef = React.createRef();
        this.itemWhConfigRef = React.createRef();
        this.ChangeItemStatusModalRef = React.createRef();
        

        this.itemUrl = INVENTORY_API_BASE_URL_2 + '/item';
        this.itemSearchFormUrl = INVENTORY_API_BASE_URL_2 + '/item/search_form_data';
        this.itemAddFormDataUrl = INVENTORY_API_BASE_URL_2 + '/item/add_form_data';
    }

    componentDidMount() {
       

        if (this.props.location.pathname !== "/item_list") {
            this.setState({ minimizeTable: true });

            // Read item name from URL search params
            const searchParams = new URLSearchParams(this.props.location.search);
            const itemNameFromUrl = searchParams.get('item_name');
            const itemCodeFromUrl = searchParams.get('item_code');
            const itemCategoryFromUrl = searchParams.get('category');

            if (itemNameFromUrl && this.props.match.params.id) {
                const validCode =
                    itemCodeFromUrl && !["null", "undefined", ""].includes(itemCodeFromUrl);

                const itemDisplayName = validCode
                    ? `${itemNameFromUrl} (${itemCodeFromUrl})`
                    : itemNameFromUrl;
            
                    this.setState({
                    itemName: itemDisplayName,
                    itemDisplayName: itemDisplayName,
                    enc_item_id: this.props.match.params.id,
                    category : itemCategoryFromUrl ? itemCategoryFromUrl : "goods",
                    tabScreen: this.props.match.params.tab || 'details'
                });
            }
        }
        this.itemSearchFormDataInit()

        this.searchItemModal = new Modal(document.getElementById('searchItemModal'), { keyboard: false, backdrop: false });
        this.itemBulkUploadModal = new Modal(document.getElementById('itemBulkUploadModal'), { keyboard: false, backdrop: false });
        this.itemBulkUpdateModal = new Modal(document.getElementById('itemBulkUpdateModal'), { keyboard: false, backdrop: false });
        this.linkInterchangeableModal = new Modal(document.getElementById('linkInterchangeableModal'), { keyboard: false, backdrop: false });
        if (this.props.item_meta) {
            this.setState({ listing_tbl_page: this.props.item_meta.current_page });
        }
        this.handleSearchParams()
        
        
    }
     handleSearchParams = () => {
        const { search } = this.props.location;
        const searchParams = new URLSearchParams(search);
        const searchText = TapHelper.sanitizeObject(searchParams.get('searchText'));
        //  if (searchParams.toString() === '' && !searchText) {
        //      this.itemSearchClear();
        //      return;
        //  }

        if (searchText) {
            this.setState(prevState => ({
                itemSearchForm: {
                    ...prevState.itemSearchForm,
                    search_by_text: searchText
                }
            }), () => {
                this.itemSearchFormSubmit();
            });
        }
        else{
        let ParamObject = new URLSearchParams(this.props.location.search);
        if (

            ParamObject.getAll("status[]").length > 0 ||
            ParamObject.getAll("item_category[]").length > 0 ||
            ParamObject.getAll("item_name[]").length > 0
        ) {
            this.setState(
                {
                    listing_loading: true,
                    listing_tbl_page: 1,
                    loadedData: false,
                    itemSearchForm: {
                        ...this.state.itemSearchForm,
                        search_status: new URLSearchParams(this.props.location.search)
                            .getAll("status[]")
                            .map((s) => parseInt(s)),
                        search_category: new URLSearchParams(this.props.location.search).getAll(
                            "item_category[]"
                        ),
                        search_name: new URLSearchParams(
                            this.props.location.search
                        ).getAll("item_name[]"),

                    },
                },
                () => {
                    setTimeout(() => {
                        this.itemSearchFormSubmit();
                    }, 1000);
                }
            );
        } else if (
            typeof this.props.item_param == "object" &&
            Object.keys(this.props.item_param).length > 0
        ) {
            this.setState(
                {
                    listing_tbl_page: this.props.item_meta.current_page,
                    itemSearchForm: {
                        ...this.state.itemSearchForm,
                        ...this.props.item_param,
                    },
                    // loadedData              :       true
                },
                () => {
                    setTimeout(() => {
                        this.itemSearchFormSubmit(null, false);
                    }, 1000);
                }
            );
        } else {
            //On  Initialize Get Item List From Server :-
            if (this.props.item_meta) {
                this.loadListingTblData(this.props.item_meta.current_page);
            } else {
                this.loadListingTblData(1);
            }
        }
        }
    }
    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            setTimeout(() => {
                this.updateCriteriaHeight();
            }, 1000);
        }
        if (this.props.location.search !== prevProps.location.search) {
             this.handleSearchParams()
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.tab !== this.state.tabScreen || nextProps.match.params.id !== this.state.enc_item_id) {
            this.setState({ tabScreen: nextProps.match.params.tab, enc_item_id: nextProps.match.params.id })
            //           
        }
    }

    itemSearchFormDataInit = () => {
        this.setState({ form_loading: true });
        HttpAPICall.withAthorization('GET', this.itemSearchFormUrl, this.props.access_token, {}, {}, (resp) => {
            this.setState({
                filterFormData: resp.data,
                allManufacturers: resp.data.manufacturers.map((m) => { return { value: m.id, label: m.name } }),
                allTags: resp.data.tags.map((m) => { return { value: m.id, label: m.name } }),
                allStatus: resp.data.status.map((m) => { return { value: m.key, label: m.name } })
            })
        }).then(() => { this.setState({ form_loading: false }) })
    }

    itemAddFormDataInit = () => {
        if (!this.state.itemFormDataLoaded) {
            HttpAPICall.withAthorization('GET', this.itemAddFormDataUrl, this.props.access_token, null, null, (response) => {
                this.setState({
                    itemFormDataLoaded: true,
                    itemAddFormData: response.data,
                });
            });
        }
    }

    formInputHandler = (e, key = 'itemSearchForm') => {
        if (key && e.target && e.target.name) {
            this.setState({ [key]: { ...this.state[key], [e.target.name]: e.target.value } });
        }
        this.setState({ loginFormErrorMsg: null });
    }

    searchFormInputHandler = (e) => {
        if (e.target && e.target.name) {
            this.setState({ itemSearchForm: { ...this.state.itemSearchForm, [e.target.name]: { ...this.state.itemSearchForm[e.target.name], value: e.target.value } } });
        }
    }
    loadListingTblData = (page = 1) => {
        this.setState({ listing_tbl_page: page });

        //  if(this.state.formSearchedElems.length == 0 || JSON.stringify(this.state.assetSearchParams) !== JSON.stringify(this.props.item_param)){
        this.props.onListingLoding();
        this.props.onListingSuccess(
            page,
            this.state.itemSearchParams,
            "Y",
            //   this.state.itemSearchedElems,
            this.state.formSearchedElems,
            this.props.access_token
        );
    };

    getItemDetails = (id) => {
        this.setState({ details_loading: true });
        HttpAPICall.withAthorization('GET', this.itemUrl + '/' + id, this.props.access_token, { opening_stock: "Y" }, {}, (resp) => {
            this.setState({ itemData: resp.data.data })
        }).then(() => { this.setState({ details_loading: false }) })
    }

   viewItemDetail = (item_id, item_name, category, item_code, item_status = 1) => {
    // Create URL with item name in search params
    let obj = { 
        item_name: item_name,
        item_code: item_code,
        category: category 
    };

   const itemDisplayName = `${item_name}${item_code ? ` (${item_code})` : ''}`;
    
    // Navigate with name in URL
    if (this.state.tabScreen !== undefined) {
        this.props.history.push({ 
            pathname: `/item_list/${this.state.tabScreen}/${item_id}`,
            search: "?" + new URLSearchParams(obj).toString()
        });
    } else {
        this.props.history.push({ 
            pathname: `/item_list/details/${item_id}`,
            search: "?" + new URLSearchParams(obj).toString()
        });
    }
    
    this.setState({ 
        minimizeTable: true, 
        itemId: item_id,
        enc_item_id: item_id,
        itemName: itemDisplayName,
        category: category,
        itemDisplayName: itemDisplayName,
        refreshDetail: false, 
        refreshInventoryLevel: false, 
        itemStatus: item_status 
    });
}
    closeMinimizeTable = () => {
        this.state?.collapseOpenClose === 'open' && this.assetListingHandler(true, 'close');
        this.setState({ minimizeTable: false });
        this.props.history.push({ pathname: `/item_list` })

    }

    itemSearchModalInit = () => {
        //Initialize Search Form :-
        this.searchItemModal.show({ focus: true });
    }

    linkInterchangeableInit = () => {
        this.linkInterchangeableModal.show();
    }

    addOpeningBalanceInit = (id, item_name) => {
 
        this.setState({
            refreshDetail: false
        })
        this.openingBalanceRef.current.modalInit(id, item_name)
    }


    // addItemWhConfigModalInit = (data = null) => {
    //     this.itemWhConfigRef.current.updateItemWarehouseConfigInit();
    // }

    linkInterchangeableModalJsx = () => {
        return (
            <div className="modal fade" id="linkInterchangeableModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">Link Interchangeable Item</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.linkItemForm} id="addModalForm">
                            <div className="modal-body">
                                <div className="row align-items-center mb-3 mt-3">
                                    <div className="col-md-4">
                                        <label className="form-label">Item Search</label>
                                    </div>
                                    <div className="col-md-8">
                                        <TapSelect
                                            isClearable={true}
                                            placeholder="Search Item"
                                            required={true}
                                        />
                                    </div>

                                </div>
                                <div className="row align-items-center mb-3 mt-3">
                                    <div className="col-md-4">
                                        <label className="form-label">Notes</label>
                                    </div>
                                    <div className="col-md-8">
                                        <textarea
                                            name="description"
                                            className="form-control"
                                            style={{ height: "80px" }}
                                        />
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    itemSearchFormSubmit = (event = null, reload = true) => {
        event && event.preventDefault();
        //Get All Keys :-
        let serachFormKeys = Object.keys(this.state.itemSearchForm);
        let searchedElems = [];
        let itemSearchedElems = {};
        let itemSearchParams = {};
        serachFormKeys.map((key) => {
            let label = this.itemSearchFormLabel[key];
            let value = this.state.itemSearchForm[key];
            if (value && value.toString().length > 0) {
                itemSearchParams[key] = value;
                if (label) {
                    let show_val = value;

                    if (key == 'search_name') {
                        show_val = this.state.itemSearchForm.search_name;
                    }
                    if (key == 'search_item_code') {
                        show_val = this.state.itemSearchForm.search_item_code;
                    }
                    if (key == 'search_category') {
                        show_val = this.state.itemSearchForm.search_category;
                    }
                    if (key == 'search_manufacturer_id') {
                        show_val = this.state.allManufacturers.filter((s) => value.includes(s.value)).map(s => s.label);
                    }
                    if (key == 'search_status') {

                        show_val = this.state.allStatus.filter((s) => value == s.value).map(s => s.label);
                    }
                    if(key == 'search_by_text') {
                         show_val            =   this.state.itemSearchForm && this.state.itemSearchForm.search_by_text ? this.state.itemSearchForm.search_by_text  : '';
                    }
                    if (key == 'search_gst_code') {
                        show_val = this.state.itemSearchForm.search_gst_code;
                    }
                    if (key == 'search_manufacturer_part_no') {
                        show_val = this.state.itemSearchForm.search_manufacturer_part_no;
                    }
                    if (key == 'search_item_tags') {
                        show_val = this.state.allTags.filter((s) => value.includes(s.value)).map(s => s.label);
                    }
                    if (key == 'search_hsn_code') {
                        show_val = this.state.itemSearchForm.search_hsn_code;
                    }

                    searchedElems.push(label + show_val);
                }
            }
        });

        //Generate Html :-
        this.props.onItemSearch(searchedElems, itemSearchParams);
        this.setState({
            formSearchedElems: searchedElems,
            itemSearchParams: itemSearchParams
        },
            () => {
                if (reload == true) {
                    this.loadListingTblData(1);
                }
                this.searchItemModal.hide();
            });
    }


    itemSearchClear = () => {
        this.props.onItemSearchClear();
        this.setState({
            itemSearchForm: this.itemSearchFormInitialState,
            formSearchedElems: [],
            itemSearchParams: null,
        }, function () {
            this.loadListingTblData(1)
            this.setState({
                criteriaHeight: 0
            })

        });
    }

    addNewItemScreenInit = () => {
        this.props.history.push('/item_list/add_item')
    }

    updateItemScreenInit = (id) => {
        this.props.history.push({ pathname: `/item_list/update_item`, state: { id: id } })
    }

    cloneItemScreenInit = (id) => {
        this.props.history.push({ pathname: `/item_list/add_item`, state: { id: id, clone: 'yes' } })
    }

    addNewItemScreenClose = () => {
        this.setState({ itemAddScreenView: false, itemUpdateScreenView: false });
    }

    afterAddNewItemSubmit = (event) => {
        event.preventDefault();
        //Item is Added Successfully Need to refresh and close Add form
        this.setState({ itemAddScreenView: false, itemUpdateScreenView: false });
        //Load Add Item Form Data :-
        this.loadListingTblData(1);
    }

    afterUpdateItemSubmit = (event, id) => {
        event && event.preventDefault();

        let itemList = this.state.listingData;
        let updatedItemIndex = this.state.listingData.findIndex((i => i.id == id));
        itemList[updatedItemIndex] = null;

        this.setState({ itemAddScreenView: false, itemUpdateScreenView: false, listingData: itemList });
        
        //Get item Details :-

        HttpAPICall.withAthorization('GET', this.itemUrl + '/' + id, this.props.access_token, {}, {})
        .then((response) => {
            let itemData = response.data.data;
            itemList[updatedItemIndex] = itemData;
            // this.setState({listingData : itemList});
            let obj = { item_name: itemData.name, item_category: itemData.category }
            this.setState({
                listingData: itemList,
                minimizeTable: true,

                // itemStatus    :    itemData?.status,
            }, () => {
                // this.props.history.push({ pathname: `/item_list/details/${itemData.id}`, })
            })
        }).catch((err) => {
            toast.error(err?.response?.data?.message ?? 'Unable to Load Item.', { position: toast.POSITION.TOP_RIGHT });
        }).then(() => {

        });
    }

    /**
     * Bulk Upload :-
     */
    itemBulkUploadModalInit = () => {
        //Initialize Search Form :-
        this.itemBulkUploadModal.show();
    }

    downloadSampleFile = () => {
        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/download_sample_add_item_excel', this.props.access_token,
            {}, {}, (response) => {
                DownloadFile.file(response.data.file_path)
                toast.success('File Downloaded Successfully', { position: toast.POSITION.TOP_RIGHT })
                this.itemBulkUploadModal.hide();
            })
    }

    itemBulkUploadFormSubmit = (event) => {
        event.preventDefault();
        this.setState({ itemBulkUploadFormSubmitting: true });
        const data = new FormData(document.getElementById('itemBulkUploadForm'));
        let headers = { 'Authorization': 'Bearer ' + this.props.access_token, };
                api.server2Api.post(this.itemUrl + '/excel_add', data, { headers: headers })
            .then((response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                this.itemBulkUploadModal.hide();
                //Load Add Item Form Data :-
                //this.loadListingTblData(1);
                DownloadFile.file(response.data.generated_file.file_path);
                setTimeout(() => {
                    this.loadListingTblData(1);
                }, 1000)
            }).catch((err) => {
                toast.error(err?.response?.data?.message ?? 'Unable to Add Item.', { position: toast.POSITION.TOP_RIGHT });
            }).then(() => {
                this.setState({ itemBulkUploadFormSubmitting: false });
            });
    }

    /**
    * Bulk Update :-
    */
    itemBulkUpdateModalInit = () => {
        //Initialize Search Form :-
        this.itemBulkUpdateModal.show();
    }


    itemBulkUpdateFormSubmit = (event) => {
        event.preventDefault();
        this.setState({ itemBulkUpdateFormSubmitting: true });
        const data = new FormData(document.getElementById('itemBulkUpdateForm'));
        let headers = { 'Authorization': 'Bearer ' + this.props.access_token, };
                api.server2Api.post(this.itemUrl + '/excel_update', data, { headers: headers })
            .then((response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                this.itemBulkUpdateModal.hide();
                //Load Add Item Form Data :-
                this.loadListingTblData(1);
            }).catch((err) => {
                toast.error(err?.response?.data?.message ?? 'Unable to Update Item.', { position: toast.POSITION.TOP_RIGHT });
            }).then(() => {
                this.setState({ itemBulkUpdateFormSubmitting: false });
            });
    }

    //******************ITEM DOWNLOAD******************** */
    itemExcelDownload = () => {
        this.setState({ excelDownloading: true });
        let searchParm = { ...this.props.itemParams };
        let params = { page: this.state.listing_tbl_page, per_page: 50, ...searchParm, download: "download" };
        HttpAPICall.withAthorization('GET', this.itemUrl, this.props.access_token, params, {}, (response) => {
            let respData = response.data
            let file_path = respData && respData.file_path ? respData && respData.file_path : '';
            let message = respData && respData.msg ? respData && respData.msg : '';
            let navigation = respData && respData.navigation ? respData && respData.navigation : '';
            download.file(file_path, message, navigation, this.props);
        })
            .then(() => this.setState({ excelDownloading: false }));
    }

    refreshInventoryLevel = () => {
        this.setState({
            refreshInventoryLevel: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    refreshInventoryLevel: false
                })
            }, 1000)
        })
    }

   
    itemDetailHandle    = (data) => {
        this.setState({
            itemDetail : data,
              itemName: data?.name
        })
    }

    assetListingJsx = () => {
        
        return (
            <div id="assetListing" className="bg-white collapse">
                <div className="page_title row m0">
                    <div className="col-12 asset_collapse mr0 pr0">
                        <h3>Item List</h3>
                        <div className="float-end">
                            <button
                                type="button"
                                onClick={() => this.assetListingHandler(true, 'close')}
                                className="btn btn-primary"
                                style={{
                                    height: "71%",
                                    lineHeight: "26px",
                                    maxHeight: "90%!important",
                                    marginTop: "10px",
                                }}
                            >
                                <tapIcon.FontAwesomeIcon icon={tapIcon.faCaretLeft} />
                            </button>
                        </div>
                    </div>
                </div>
                <div className=" bg-white position-relative z_index" >
                    <div className="page_containt row" >
                        <div className="pageTbl col-12">
                            <DisplaySearchCriteria searchedElems={this.props.searchedElems} onClearFilter={this.itemSearchClear} />
                            <table className="table table-bordered table-hover table-sm table-fixed bg-white">
                                <thead className="table-secondary">
                                    <tr> <th scope="col" style={{ width: "15%" }}> Item  </th> </tr>
                                </thead>
                                <tbody>
                                    {this.props.item_listing_loaded ? (
                                        <tr>
                                            <td className="text-center" colSpan="9">
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : this.props.item_listing?.length > 0 ? (
                                        this.props.item_listing.map((item, index) =>
                                            this.listingJsx(item, index)
                                        )
                                    ) : (
                                        this.listingJsx(null)
                                    )}
                                    
                                </tbody>
                            </table>
                            <DisplayListPagination
                                meta={this.props.item_meta}
                                onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
                            />
                        </div>
                    </div>
                </div>

            </div>

        );
    };
    assetListingHandler = (collapse = true, type = 'open') => {
        this.setState({
            collapseOpenClose: type
        });

        collapse && new Collapse(document.getElementById("assetListing"));
    };

    itemListjsx = () => {
        let ParamObject = new URLSearchParams(this.props.location.search);
        
         let itemName = this.state.itemName;
        
        let { location } = this.props;
        let searchParams = '';
        if (location && location.search) {
            searchParams = new URLSearchParams(location.search);
        }

        let itemData = this.props.item_listing && this.props.item_listing.length > 0 ? this.props.item_listing.find((item) => item.id == this.state.enc_item_id) : null;
        console.log('itemData', itemData)
        return (<Ax>
            <div className="page_title row m0">
                {this.state.minimizeTable ? null :
                    <div>
                        <h3 >Item List</h3>
                        <div className="text-end mt15">
                            {(!this.state.minimizeTable) ? <button type="button" disabled={this.state.excelDownloading == true || !this.props?.permissions?.includes('isc-item-add')} onClick={this.addNewItemScreenInit} className="btn btn-primary">New Item</button> : null}
                            <button type="button" onClick={this.itemSearchModalInit} className="btn btn-secondary " disabled={this.state.excelDownloading == true}>
                                <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                            </button>
                            <span className="dropdown">
                                <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary" disabled={this.state.excelDownloading == true}>
                                    <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {this.state.minimizeTable ?
                                        <li>
                                            <button role="button"
                                                onClick={() => {
                                                    if (this.props?.permissions?.includes('isc-item-add')) {
                                                        return this.addNewItemScreenInit()
                                                    }
                                                }}
                                                className={['dropdown-item', this.props?.permissions?.includes('isc-item-add') ? '' : 'disabled'].join(' ')}
                                                title={!this.props?.permissions?.includes('isc-item-add') ? 'You do not have permission to perform this action' : ''}
                                                style={{ "pointerEvents": "all" }}
                                            >New Item</button>


                                        </li> : null}
                                    <li>
                                        <button role="button"
                                            onClick={() => {
                                                if (this.props?.permissions?.includes('isc-item-add')) {
                                                    return this.itemBulkUploadModalInit()
                                                }
                                            }}
                                            className={['dropdown-item', this.props?.permissions?.includes('isc-item-add') ? '' : 'disabled'].join(' ')}
                                            title={!this.props?.permissions?.includes('isc-item-add') ? 'You do not have permission to perform this action' : ''}
                                            style={{ "pointerEvents": "all" }}
                                        >Bulk Upload</button>
                                    </li>
                                    <li>
                                        <button role="button"
                                            onClick={() => {
                                                if (this.props?.permissions?.includes('isc-item-edit')) {
                                                    return this.itemBulkUpdateModalInit()
                                                }
                                            }}
                                            className={['dropdown-item', this.props?.permissions?.includes('isc-item-edit') ? '' : 'disabled'].join(' ')}
                                            title={!this.props?.permissions?.includes('isc-item-edit') ? 'You do not have permission to perform this action' : ''}
                                            style={{ "pointerEvents": "all" }}
                                        >Bulk Update</button>
                                    </li>
                                    <li><a className="dropdown-item" onClick={this.itemExcelDownload} role="button" >Download</a></li>
                                </ul>
                            </span>
                        </div>
                    </div>}
                {
                    this.state.minimizeTable
                        ? (
                            <div className=" tap_border_left ps-0 ">
                                <div className='row justify-content-between '>
                                    <div className='col-7'>
                                        <div className='d-flex'>
                                            <div>
                                                <button
                                                    type="button"
                                                    onClick={() => this.assetListingHandler(true, 'open')}
                                                    className="btn btn-primary "
                                                    style={{
                                                        height: "73%",
                                                        marginTop: "10px",
                                                        marginLeft: "-5px"
                                                    }}
                                                >
                                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faCaretRight} />
                                                </button>
                                            </div>
                                            <h3 className='ms-2'>Item : {itemName ? itemName.slice(0, 45) : ''}{itemName && itemName.length > 45 ? '...' : ''}</h3>
                                        </div>
                                    </div>
                                    <div className=" col-5 ">
                                        <div className=" text-end  mt15">
                                            {itemName !== ''
                                                ? <button

                                                    onClick={() => {
                                                        this.state?.collapseOpenClose === 'open' && this.assetListingHandler(true, 'close')
                                                        this.updateItemScreenInit(this.state.enc_item_id)
                                                    }}

                                                    type="button" className="btn btn-secondary" disabled={!this.props?.permissions?.includes('isc-item-edit')}>
                                                    Edit Item</button>
                                                : null
                                            }
                                            <button type="button" className="btn btn-secondary" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                                                <tapIcon.FontAwesomeIcon icon={tapIcon.faChartBar} className=" mr3" />
                                                Report</button>
                                            <ul className="dropdown-menu dropdown-menu-end" style={{ cursor: "pointer" }}>
                                                <li><Link className="dropdown-item" to={{ pathname: `/report/item_wise_allocation`, search: "?" + new URLSearchParams({ search_item_ids: this.state.enc_item_id, item_name: itemName }).toString() }}>Item wise Allocation</Link></li>
                                                <li><Link className="dropdown-item" to={{ pathname: `/report/item_wise_consumption`, search: "?" + new URLSearchParams({ search_item_ids: this.state.enc_item_id, item_name: itemName }).toString() }}>Item wise Consumption</Link></li>
                                                <li><Link className="dropdown-item" to={{ pathname: `/report/item_wise_purchase`, search: "?" + new URLSearchParams({ search_item_ids: this.state.enc_item_id, item_name: itemName }).toString() }}>Item wise Purchase</Link></li>
                                                {this.props.permissions.includes('isc-po-view') && <li><Link className="dropdown-item" to={{ pathname: `/report/item_wise_purchase_order`, search: "?" + new URLSearchParams({ search_item_ids: this.state.enc_item_id, item_name: itemName }).toString() }}>Item wise Purchase Order</Link></li>}
                                                <li><Link className="dropdown-item" to={{ pathname: `/report/item_wise_requisition`, search: "?" + new URLSearchParams({ search_item_ids: this.state.enc_item_id, item_name: itemName }).toString() }}>Item wise Purchase Requisition</Link></li>
                                                <li><Link className="dropdown-item" to={{ pathname: `/report/item_stock_transaction_ledger`, search: "?" + new URLSearchParams({ search_item_ids: this.state.enc_item_id, item_name: itemName }).toString() }}>Item wise Transaction Ledger</Link></li>
                                                <li><Link className="dropdown-item" to={{ pathname: `/report/item_closing_stock`, search: "?" + new URLSearchParams({ search_item_ids: this.state.enc_item_id, item_name: itemName }).toString() }}>Inventory Closing Stock</Link></li>
                                                <li><Link className="dropdown-item" to={{ pathname: `/report/inventory_forecasting_report`, search: "?" + new URLSearchParams({ search_item_ids: this.state.enc_item_id, item_name: itemName }).toString() }}>Inventory Forecasting Report</Link></li>
                                            </ul>
                                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                                <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                            </button>
                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li><a className="dropdown-item cursor_pointer" onClick={() => this.cloneItemScreenInit(this.state.enc_item_id)}>Clone</a></li>
                                                <li>
                                                    <button role="button"
                                                        onClick={() => {
                                                            this.state?.collapseOpenClose === 'open' && this.assetListingHandler(true, 'close')
                                                            if (this.props?.permissions?.includes('isc-item-opening-balance')) {
                                                                return this.addOpeningBalanceInit(this.state.enc_item_id, itemData)
                                                            }
                                                            
                                                        }}
                                                        className={['dropdown-item cursor_pointer', this.props?.permissions?.includes('isc-item-opening-balance') ? '' : 'disabled'].join(' ')}
                                                        title={!this.props?.permissions?.includes('isc-item-opening-balance') ? 'You do not have permission to perform this action' : ''}
                                                        style={{ "pointerEvents": "all" }}
                                                    >Add Opening Balance</button>
                                                </li>
                                
                                                <li>
                                                    <a role="button"
                                                        onClick={() => {
                                                            if (this.props.permissions.includes('isc-item-change-status')) {
                                                                if (this.ChangeItemStatusModalRef && this.ChangeItemStatusModalRef.current) {
                                                                    return this.ChangeItemStatusModalRef.current.changeStatusModalInit(this.state.enc_item_id,itemData)
                                                                }
                                                            }
                                                        }}
                                                        className={['dropdown-item cursor_pointer', this.props.permissions.includes('isc-item-change-status') ? '' : 'disabled'].join(' ')}
                                                        title={!this.props.permissions.includes('isc-item-change-status') ? 'You do not have permission to perform this action' : ''}
                                                        style={{ "pointerEvents": "all" }}
                                                    >Change Item Status</a>
                                                </li>
                                          
                                               

                                                {this.state.tabScreen == 'inventory' && <li><a className="dropdown-item cursor_pointer" onClick={() => { this.refreshInventoryLevel() }}>Refresh Inventory Level</a></li>}
                                            </ul>
                                            <button onClick={this.closeMinimizeTable} type="button" className="btn btn-secondary">
                                                <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        : null
                }
            </div>
            <div className=" position-relative ">
                <div className=" col-12">
                    <div className="container-fluid pl5" >
                        <div className="page_containt row" >

                            <div className='col-12' style={{ paddingRight: "0px", overflowX: "hidden" }}>
                                {this.state.minimizeTable ? null : <> {this.groupListingTableJsx()}</>}
                                <div className='row' style={{ overflowY: "no-scroll" }}>
                                    {this.state.minimizeTable ? <div className="col-9 " >
                                      
                                        <ReusableItemTabs
                                            category={this.state.category ? this.state.category : "goods"}
                                             ref={this.itemWhConfigRef} 
                                            extraProps={{
                                                refreshDetail: this.state.refreshDetail,
                                                refreshInventoryLevel: this.state.refreshInventoryLevel,
                                                itemDetail: this.state.itemDetail,
                                                onRefreshComplete: () => {
                                                    // Reset refreshDetail after child component has refreshed
                                                    this.setState({ refreshDetail: false });
                                                },
                                                ...this.props
                                            }}
                                            
                                        />
                                    </div> : null}
                                    {this.state.minimizeTable ? <div className="col-3 pl4 pe-3  page_containt" style={{ top: "0px" }}>
                                        <ItemCard
                                            item_enc_id={this.state.enc_item_id}
                                            refreshDetail={this.state.refreshDetail}
                                            onRefreshComplete={() => {
                                                // Reset refreshDetail after card updates
                                                this.setState({ refreshDetail: false });
                                            }}
                                            itemData={this.state.itemDetail}
                                        /></div> : null}
                                </div>
                            </div>
                        </div>
                    </div></div>
            </div>
            <ChangeItemStatus ref={this.ChangeItemStatusModalRef} afterChangeStatus={() => { this.setState({ refreshDetail: true, refreshInventoryLevel: true }, () => { this.loadListingTblData(this.state.listing_tbl_page); this.afterUpdateItemSubmit(null, this.state.enc_item_id); }); }} />
        </Ax>);
    }

    groupListingTableJsx = () => {

        return (
            <Ax >
                <div className="pageTbl col-12 " style={{ height: "83vh" }}>
                     <div ref={this.criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
                    <DisplaySearchCriteria searchedElems={this.props.itemElems} onClearFilter={this.itemSearchClear} />
                    </div>
                    <table className="table table-bordered  bg-white table-sm pb-5">
                        <thead className="table-secondary "style={{top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }} >
                            {this.state.minimizeTable
                                ? (<tr>
                                    <th scope="col" style={{ width: "15%" }}>Item Name (Code)</th>
                                </tr>)
                                : (<tr>
                                    <th className='text-center' scope="col" style={{ width: "5%" }}>#</th>
                                    <th scope="col" style={{ width: "18%" }}>Item Name</th>
                                    <th scope="col" style={{ width: "13%" }}>Item Code</th>
                                    <th scope="col" style={{ width: "7%" }}>Item Number</th>
                                    <th scope="col" style={{ width: "17%" }}>Manufacturer</th>
                                    <th scope="col" style={{ width: "10%" }}>MPN</th>
                                    <th scope="col" style={{ width: "9%" }}>UOM</th>
                                    <th scope="col" style={{ width: "8%" }} className='text-center'>Status</th>
                                    <th scope="col" style={{ width: "5%" }}>Action</th>
                                </tr>)
                            }
                        </thead>
                        <tbody>
                            {this.props.item_listing_loaded ? (
                                <tr>
                                    <td className="text-center" colSpan="9">
                                        <Loader />
                                    </td>
                                </tr>
                            ) : this.props.item_listing.length > 0 ? (
                                this.props.item_listing.map((item, index) =>
                                    this.listingTableTrJsx(item, index)
                                )
                            ) : (
                                this.listingTableTrJsx(null)
                            )}
                            {/* {this.state.listing_loading
                                ? <tr><td className="text-center" colSpan="8"><Loader /></td></tr>
                                : this.state.listingData.length > 0
                                    ? this.state.listingData.map((item, index) => this.listingTableTrJsx(item, index))
                                    : <tr><td className="text-center" colSpan="8">No Record Found</td></tr>} */}
                        </tbody>
                    </table>

                    <DisplayListPagination
                        meta={this.props.item_meta}
                        onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
                    />
                </div>
            </Ax>
        );
    }
    listingJsx = (item, index) => {
        
        if (item) {
            return (
                <tr key={index}>


                    <Ax>

                        <td>
                            <a role="button"
                                onClick={() => {
                                    this.state?.collapseOpenClose === 'open' && this.assetListingHandler(true, 'close')
                                    this.viewItemDetail(item.id, item.name, item.category, item?.item_code, item?.status)
                                }}
                                className="link-primary">{item.name}</a>
                            <br /><small>Code : {item.item_code}</small>
                            <small className="float-end">
                                <Status color={item.status_color}>
                                    {item.status_text}
                                </Status>
                            </small>
                        </td>

                    </Ax>




                </tr>
            );
        } else {
            return (
                <tr key={index}><td colSpan={this.state.minimizeTable ? 1 : 8}><Loader /></td></tr>
            );
        }
    }
    listingTableTrJsx = (item, index) => {
        if (item) {
            return (
                <tr key={index} >

                    <Ax>
                        <td className='text-center'>{this.props.item_meta ? this.props.item_meta.from + index : index}{" "} </td>
                        <td><a role="button" onClick={() => this.viewItemDetail(item.id, item.name, item.category, item?.item_code, item?.status)} className="link-primary text-capitalize">{item.name}</a></td>
                        <td className='text-capitalize'>{item.item_code}</td>
                        <td className='text-capitalize'>{item.item_number}</td>
                        <td className='text-capitalize'>{item.manufacturer ? item.manufacturer.name : '-'}</td>
                        <td className='text-capitalize'>{item.manufacturer_part_no ? item.manufacturer_part_no : '-'}</td>
                        <td>{item.measuring_unit ? item.measuring_unit.name : '-'}</td>
                        <td className='text-center'><Status color={item.status_color}>{item.status_text}</Status></td>
                        <td >
                            <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a className="dropdown-item" onClick={() => this.updateItemScreenInit(item.id)} role="button">Edit Item</a></li>
                            </ul>
                        </td>
                    </Ax>


                </tr>
            );
        } else {
            return (
                <tr key={index}> <td className="text-center" colSpan={9}>
          No Records Found
        </td></tr>
            );
        }
    }



    itemSearchModalJsx = () => {
        return (
            <div className="modal fade" id="searchItemModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchItemModalLabel">Item Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        {this.state.form_loading ? <Loader />
                            : <form onSubmit={this.itemSearchFormSubmit} id="itemSearchForm">
                                <div className="modal-body">
                                    <div className="row">
                                        <label className="col-sm-2 col-form-label col-form-label-sm text-end"> Item Name</label>
                                        <div className='col-sm-4'>
                                            <input
                                                type="text"
                                                name="search_name"
                                                value={this.state.itemSearchForm.search_name}
                                                className="form-control form-control-sm"
                                                onChange={(e) => this.formInputHandler(e, 'itemSearchForm')}
                                                placeholder="Item Name"
                                                autoComplete="off"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm text-end"> Item Code</label>
                                        <div className='col-sm-4'>
                                            <input
                                                type="text"
                                                name="search_item_code"
                                                value={this.state.itemSearchForm.search_item_code}
                                                className="form-control form-control-sm"
                                                onChange={(e) => this.formInputHandler(e, 'itemSearchForm')}
                                                placeholder="Item Code"
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <label className="col-sm-2 col-form-label col-form-label-sm text-end"> Item Category</label>
                                        <div className='col-sm-4'>
                                            {
                                                this.state.filterFormData && this.state.filterFormData.category
                                                    ? (this.state.filterFormData.category.map((cat, k) => {
                                                        return (
                                                            <div key={cat.index} className="form-check form-check-inline my-1">
                                                                <input
                                                                    name="search_category"
                                                                    type="radio"
                                                                    value={cat.index}
                                                                    onChange={(e) => this.formInputHandler(e, 'itemSearchForm')}
                                                                    checked={this.state.itemSearchForm.search_category === cat.index}
                                                                    className="form-check-input"
                                                                    id={cat.index}
                                                                />
                                                                <label className="form-check-label form-label-sm" htmlFor={cat.index}>{cat.item}</label>
                                                            </div>);
                                                    }))
                                                    : null
                                            }
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm text-end">Item Tags</label>
                                        <div className='col-sm-4'>
                                            <TapSelect
                                                changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'itemSearchForm', 'search_item_tags')}
                                                options={this.state.allTags}
                                                isSearchable={true}
                                                isClearable={true}
                                                value={this.state.allTags.filter(t => this.state.itemSearchForm.search_item_tags.includes(t.value))}
                                                placeholder="Please Select Tag"
                                                isMulti={true}
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>

                                    </div>
                                    <div className="row my-3">
                                        <label className="col-sm-2 col-form-label col-form-label-sm text-end"> Manufacturer</label>
                                        <div className='col-sm-4'>
                                            <TapSelect
                                                changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'itemSearchForm', 'search_manufacturer_id')}
                                                options={this.state.allManufacturers}
                                                isSearchable={true}
                                                isClearable={true}
                                                value={this.state.allManufacturers.find(m => m.value == this.state.itemSearchForm.search_manufacturer_id)}
                                                placeholder="Please Select"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm text-end">MPN</label>
                                        <div className='col-sm-4'>
                                            <input
                                                type="text"
                                                name="search_manufacturer_part_no"
                                                value={this.state.itemSearchForm.search_manufacturer_part_no}
                                                className="form-control form-control-sm"
                                                onChange={(e) => this.formInputHandler(e, 'itemSearchForm')}
                                                placeholder="Search MPN"
                                                autoComplete="off"
                                            />
                                        </div>

                                    </div>
                                    <div className="row my-3">
                                        <label className="col-sm-2 col-form-label col-form-label-sm text-end">HSN / SAC Code</label>
                                        <div className='col-sm-4'>
                                            <input
                                                type="text"
                                                name="search_hsn_code"
                                                value={this.state.itemSearchForm.search_hsn_code}
                                                className="form-control form-control-sm"
                                                onChange={(e) => this.formInputHandler(e, 'itemSearchForm')}
                                                placeholder="Search HSN / SAC Code"
                                                autoComplete="off"
                                            />
                                        </div>
                                        <label className="col-sm-2 col-form-label col-form-label-sm text-end">Item Status</label>
                                        <div className='col-sm-4'>
                                            <TapSelect
                                                changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'itemSearchForm', 'search_status')}
                                                options={this.state.allStatus}
                                                isSearchable={true}
                                                isClearable={true}
                                                value={this.state.allStatus.find(t => this.state.itemSearchForm.search_status == t.value)}
                                                placeholder="Please Select Status"
                                                containerHeight="30px"
                                                fontSize="93%"
                                            />
                                        </div>

                                    </div>
                                    <div className="row my-3">
                                         <label className="col-sm-2 col-form-label col-form-label-sm">Search Text</label>
                                            <div className="col-sm-4">
                                                <input
                                                    name="search_by_text"
                                                    type="text"
                                                    value={this.state.itemSearchForm.search_by_text}
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "itemSearchForm")}
                                                    placeholder="Please enter Text"
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                />
                                            </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button type="submit" className="btn btn-primary">Search</button>
                                </div>
                            </form>}
                    </div>
                </div>
            </div>
        );
    }

    itemBulkUploadModalJsx = () => {
        return (
            <div className="modal fade" id="itemBulkUploadModal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="itemBulkUploadModalLabel">Bulk Upload Item</h5>
                            <button type="button" disabled={this.state.itemBulkUploadFormSubmitting} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.itemBulkUploadFormSubmit} id="itemBulkUploadForm" method="post" encType="multipart/form-data">
                            <div className="modal-body">
                                <div className="row align-items-center mb-3 mt-3">
                                    <div className="col-12">
                                        <input
                                            name="document"
                                            type="file"
                                            className="form-control"
                                            required={true}
                                        />
                                    </div>
                                    <div className="col-12 mt-2 form-text"># Excel Sheet with Extention xls,xlm,xlsx,ods Allowed</div>
                                    <div className="col-12 mt-2 form-text"># Miximum 100 MB Size of Excel Sheet Allowed</div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-between">
                                <div><a type="button" className='float-left' href='#' onClick={this.downloadSampleFile}>Download Sample File</a></div>
                                <div>
                                    <button type="button" disabled={this.state.itemBulkUploadFormSubmitting} className="btn btn-secondary mx-2" data-bs-dismiss="modal">Close</button>
                                    <button type="submit" disabled={this.state.itemBulkUploadFormSubmitting} className="btn btn-primary">
                                        Submit {this.state.itemBulkUploadFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    itemBulkUpdateModalJsx = () => {
        return (
            <div className="modal fade" id="itemBulkUpdateModal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="itemBulkUploadModalLabel">Bulk Update Item</h5>
                            <button type="button" disabled={this.state.itemBulkUpdateFormSubmitting} className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.itemBulkUpdateFormSubmit} id="itemBulkUpdateForm" method="post" encType="multipart/form-data">
                            <div className="modal-body">
                                <div className="row align-items-center mb-3 mt-3">
                                    <div className="col-12">
                                        <input
                                            name="document"
                                            type="file"
                                            className="form-control"
                                            required={true}
                                        />
                                    </div>
                                    <div className="col-12 mt-2 form-text"># Excel Sheet with Extention xls,xlm,xlsx,ods Allowed</div>
                                    <div className="col-12 mt-2 form-text"># Miximum 100 MB Size of Excel Sheet Allowed</div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" disabled={this.state.itemBulkUpdateFormSubmitting} className="btn btn-secondary mx-2" data-bs-dismiss="modal">Close</button>
                                <button type="submit" disabled={this.state.itemBulkUpdateFormSubmitting} className="btn btn-primary">
                                    Submit {this.state.itemBulkUpdateFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }


    render = () => {
        return (<ApplicationLayout>
            <Helmet><title>Item Listing</title></Helmet>
            <div style={{ overflow: "hidden" }}>
                <div className="asset_collapse">
                    <div className="asset_table">{this.assetListingJsx()}</div>
                    {this.itemListjsx()}
                    {this.itemSearchModalJsx()}
                    {this.itemBulkUploadModalJsx()}
                    {this.linkInterchangeableModalJsx()}
                    {this.itemBulkUpdateModalJsx()}
                </div>
                <OpeningBalanceAddModal
                    ref={this.openingBalanceRef}
                    afterSubmitForm={() => {
                        this.setState({
                            refreshDetail: true,
                           // refreshInventoryLevel : true
                        },() => {
                             this.refreshInventoryLevel()
                        })
                    }}
                />
            </div>
            {/* <ItemWhConfigModel ref={this.addConfigRef} item_id={this.state.enc_item_id}/> */}
        </ApplicationLayout>);
    }

}


const mapStateToProps = state => {

    return {
        access_token: state.auth.access_token,
        itemElems: state.app.search_elem && state.app.search_elem.length > 0 ? state.app.search_elem : [],
        itemParams: state.app.search_param,
        searchedElems:
            state.app && state.app.formSearchedElems
                ? state.app.formSearchedElems
                : [],
        item_param:
            state.app && state.app.item_search_param
                ? state.app.item_search_param
                : {},
        item_listing_loaded:
            state.app && state.app.item_listing_loaded
                ? state.app.item_listing_loaded
                : false,
        item_listing:
            state.app && state.app.item_listing ? state.app.item_listing : [],
        item_meta: state.app && state.app.item_meta ? state.app.item_meta : null,
        permissions: state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onItemSearch: (search_elem, search_param) => dispatch(actions.itemSearch(search_elem, search_param)),
        onItemSearchClear: () => dispatch(actions.itemSearchClear()),
        onListingLoding: (data) =>
            dispatch(actions.itemListingDataInitilization()),
        onListingSuccess: (page, searchParm, cl_attribute, formSearchedElems,access_token) =>
            dispatch(
                actions.itemListingDataLoading(
                    page,
                    searchParm,
                    cl_attribute,
                    formSearchedElems,
                    access_token
                )
            ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ItemList);